import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { QueryType } from 'enums/QueryType';
import { environment } from "environments/environment";
import { QueryModel } from 'models/generated/Entities.GormCrm.Query';
import { DynamicQueryModel } from 'models/generated/Models.DynamicQuery';
import { SaveQueryRequestModel } from 'models/generated/Models.Query.SaveQueryRequest';
import { QueryPropertyModel } from 'models/generated/Models.QueryProperty';
import { firstValueFrom } from 'rxjs';

@Injectable()
export class QueryService {
	private baseUrl = `${environment.gatewayUrl}/api/queries`;

	constructor(private readonly http: HttpClient) { }


	getQuery(id: string): Promise<QueryModel> {
		return firstValueFrom(this.http.get<QueryModel>(`${this.baseUrl}/${id}`));
	}

	getQueries(): Promise<QueryModel[]> {
		return firstValueFrom(this.http.get<QueryModel[]>(`${this.baseUrl}`));
	}

	saveQuery(query: QueryModel, queryData: DynamicQueryModel): Promise<QueryModel> {
		const request = new SaveQueryRequestModel();
		request.query = query;
		request.queryData = queryData;
		request.include(r => r.query);
		request.include(r => r.queryData);
		return firstValueFrom(this.http.post<QueryModel>(`${this.baseUrl}`, request));
	}

	deleteQuery(queryId: string): Promise<void> {
		return firstValueFrom(this.http.delete<void>(`${this.baseUrl}/${queryId}`));
	}

	getQueryProperties(queryType: QueryType): Promise<QueryPropertyModel[]> {
		return firstValueFrom(this.http.get<QueryPropertyModel[]>(`${this.baseUrl}/get-query-properties/${queryType}`));
	}

	executeFilterQuery<T>(dynamicQuery: DynamicQueryModel): Promise<T> {
		dynamicQuery.include(query => query.filters);
		dynamicQuery.filters.forEach(filter => filter.include(f => f.property));
		return firstValueFrom(this.http.post<T>(`${this.baseUrl}/execute-dynamic-query`, dynamicQuery));
	}
}
